import {Fragment} from 'react';

const Question: (props: any) => JSX.Element = (props: any) => {

    const {children} = props;

    return (
        <Fragment>
            <div className="text-[1.4rem] md:text-[2.4rem] font-semibold mb-10">
                {children}
            </div>
        </Fragment>
    );
}

export default Question;
